
###
TODO:
	- Make a "filter" component that is just the markup, and consume it twice
	to make a desktop filter and a mobile filter
###
import DataBinding from './mixins/data-binding'
import HeightTween from 'vue-height-tween-transition'

export default
	components: { HeightTween }

	data: ->
		# display mobile filtering controls
		showMobileControls: false

	computed:
		# the expand/retract icon
		icon: -> if @showMobileControls then 'x' else "+"

		# The text to display on mobile control button
		buttonControlText: -> if !@showMobileControls then "Filter" else "Close"

	mixins: [DataBinding]

